import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";

import TextField from "../../../../components/FormElements/TextField";
import SelectField from "../../../../components/FormElements/SelectField";
import ImgUpload from "../../../../components/FormElements/ImgUpload";

import { countries as countriesData } from "../../../../constants/countries";
import { specialties as specialtiesData } from "../../../../constants/specialties";
import { email, required, maxLength80, maxLength140 } from "../../../../util/formValidations";

import Button from "../../../../components/Button";
import OverlayLoader from "../../../../components/OverlayLoader";
import "./index.css";
import { FormHelperText } from "material-ui/Form";

class SettingsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countries: countriesData.map(({ countryName }) => ({ value: countryName, name: countryName })),
      specialties: specialtiesData.map(specialty => ({ value: specialty, name: specialty })),
    };
  }

  render() {
    const { handleSubmit, accessToken, isLoading, submitting, error, onCancel } = this.props;
    const { countries, specialties } = this.state;
    return (
      <form className="form" onSubmit={handleSubmit}>
        {(isLoading || submitting) && <OverlayLoader />}
        <Field name="picture" component={ImgUpload} accessToken={accessToken} />
        <Field name="name" component={TextField} label="Name" validate={[required]} />
        <Field name="headline" component={TextField} label="Headline" validate={[maxLength80]} />
        <Field name="email" component={TextField} label="Email" validate={[required, email]} />
        <Field
          name="speciality"
          component={SelectField}
          label="Speciality"
          validate={[required]}
          options={specialties}
        />
        <Field name="shortBio" component={TextField} label="Bio" multiline rows="2" validate={[maxLength140]} />
        <Field name="country" component={SelectField} label="Country" options={countries} validate={[required]} />
        <div className="controls">
          <Button value="cancel" className="-cancel" onClick={onCancel} />
          <Button value="submit" type="submit" />
        </div>
        <FormHelperText error>{error}</FormHelperText>
      </form>
    );
  }
}

export default reduxForm({ form: "settingsForm" })(SettingsPage);



// WEBPACK FOOTER //
// ./src/scenes/EditProfilePage/components/SettingForm/index.js